import { useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useMe } from '../../lib/api'
import { Spinner } from '../ui/misc'
import { NoOrganization } from '../../pages/NoOrganization'
import { PendingAccess } from '../../pages/PendingAccess'
import { Wordmark } from './Logo'
import { MobileMenuButton, Sidebar } from './Sidebar'

/** Signed-in layout. Unauthenticated visitors go to /login and come back afterwards. */
export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const { data: me, isLoading } = useMe()
  const loc = useLocation()
  if (isLoading) return <Spinner />
  if (!me?.user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />
  const hasOrg = Boolean(me.activeOrgId && me.orgs?.some((o) => o.id === me.activeOrgId))
  const waiting = me.access === 'pending' || me.access === 'rejected'
  // pages that need no organization: personal settings, and the API guide (open to people waiting for access)
  const open = loc.pathname.startsWith('/settings/profile') || (waiting && loc.pathname.startsWith('/docs'))

  return (
    <div className="flex h-screen bg-surface-sunken">
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col md:pt-2">
        <div className="flex items-center gap-2 border-b border-line bg-surface px-3 py-2 md:hidden">
          <MobileMenuButton onClick={() => setMobileOpen(true)} />
          <Wordmark />
        </div>
        <main className="min-h-0 flex-1 overflow-hidden bg-surface shadow-token-sm md:rounded-tl-2xl md:border-l md:border-t md:border-line">
          {open || (hasOrg && !waiting) ? <Outlet /> : waiting ? <PendingAccess /> : <NoOrganization />}
        </main>
      </div>
    </div>
  )
}
